import { Box, Button } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../../components/LoadingSpinner";
import Table1 from "../../components/Table/Table1";
import boxStyles from "../../styles/boxStyles";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import IMDashboard from "./Component/IMDashboard";
import ButtonUser from "./Component/ButtonUser";
import ApiService from "../../services/ApiService";

import { DataGrid } from "@mui/x-data-grid";
import TableAtas from "../../components/Table/TableAtas";
import TableBawah from "../../components/Table/TableBawah";
import { useAuth } from "oidc-react";

const IncidentManagement = () => {
  const { userData } = useAuth();
  const [dataRegion, setDataRegion] = useState([]);
  const [dataLokasi, setDataLokasi] = useState([]);
  const [dataTahun, setDataTahun] = useState([]);

  // Fetch Data
  useEffect(() => {
    getDataRegion();
    // getDataLokasi();
    getDataTahun();
    // eslint-disable-next-line
  }, []);

  const [data, setData] = useState([]);
  const history = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const getDataRegion = () => {
    ApiService.getMsRegional().then((res) => {
      var result = res.data.payload;
      setDataRegion(result);
    });
  };
  const getDataLokasi = () => {
    ApiService.getMsLokasi().then((res) => {
      var result = res.data.payload;
      setDataLokasi(result);
    });
  };
  const getDataTahun = () => {
    ApiService.getMsTahun().then((res) => {
      var result = res.data.payload;
      setDataTahun(result);
    });
  };

  // Action Table
  const CreateData = (id) => {
    alert("Buat LKP " + id);
  };
  const EditData = (id) => {
    history("/hsse/incident/" + id);
  };

  // Tabel baru
  const newCol = useMemo(
    () => [
      {
        id: "nomorLaporan",
        label: "No Laporan",
      },
      {
        id: "judulLaporan",
        label: "Judul",
      },
      {
        id: "dateReported",
        label: "Date Reported",
      },
      {
        id: "statusLaporan",
        label: "Status",
      },
      {
        id: "laporanKejadianId",
        label: "",
      },
    ],
    []
  );

  const newMainContainer = (
    <>
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        sx={{ m: 1, minWidth: 120 }}
        onClick={() => history("/hsse/incident/createlkp")}
      >
        New LKP
      </Button>
      <TableAtas columns={newCol} data={data} EditData={EditData} />
    </>
  );

  const newCol2 = useMemo(
    () => [
      {
        id: "nomorLaporan",
        label: "No LKP",
      },
      {
        id: "judulLaporan",
        label: "Judul",
      },
      {
        id: "tanggalLaporan",
        label: "Date Reported",
      },
      {
        id: "tipeIncident",
        label: "Tipe Incident",
      },
      {
        id: "statusLaporan",
        label: "Status",
      },
      {
        id: "nomorinvestigasi",
        label: "No Investigasi",
      },
      { id: "statusinvestigasi", label: "Status Investigasi" },
      { id: "sladate", label: "SLA Date" },
      {
        id: "action",
        label: "",
      },
    ],
    []
  );

  const newMainContainer2 = (
    <>
      {/* <ButtonUser
        dataRegion={dataRegion}
        dataLokasi={dataLokasi}
        dataTahun={dataTahun}
      /> */}
      <TableBawah
        columns={newCol2}
        data={data}
        CreateData={CreateData}
        EditData={EditData}
      />
    </>
  );

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: 0,
      }}
    >
      <p>Login as {userData?.profile?.display_name}</p>
      <h1>Incident Management</h1>

      <IMDashboard
        dataRegion={dataRegion}
        dataLokasi={dataLokasi}
        dataTahun={dataTahun}
      />
      <br></br>

      <Box component="div" sx={boxStyles} id="tabel">
        {/* Table Atas */}
        {/* {isLoading ? <LoadingSpinner /> : mainContainer} */}
        {isLoading ? <LoadingSpinner /> : newMainContainer}
        {errorMessage && <div className="error">{errorMessage}</div>}
        <iframe
          id="ifmcontentstoprint"
          title="myFrame"
          style={{ height: "0px", width: "0px", position: "absolute" }}
        ></iframe>
      </Box>

      <br></br>
      <Box component="div" sx={boxStyles} id="tabel">
        {/* Table Bawah */}
        {isLoading ? <LoadingSpinner /> : newMainContainer2}
        {errorMessage && <div className="error">{errorMessage}</div>}
        <iframe
          id="ifmcontentstoprint"
          title="myFrame"
          style={{ height: "0px", width: "0px", position: "absolute" }}
        ></iframe>
      </Box>
    </Box>
  );
};

export default IncidentManagement;
